import { BCMSRecord, Workflow, useBCMSContext } from "@bcm-dev/bcms-vite";
import AddUnlinkedTransferAccountChoiceView from "components/custom-ui/CustomModal/components/AddUnlinkedTransferAccountModal/components/AddUnlinkedTransferAccountChoiceView";
import AddUnlinkedTransferToAnotherMembersAccountView from "components/custom-ui/CustomModal/components/AddUnlinkedTransferAccountModal/components/AddUnlinkedTransferToAnotherMembersAccountView";
import Classes from "model";

// Steps of the workflow
var steps = [
    AddUnlinkedTransferAccountChoiceView,
    AddUnlinkedTransferToAnotherMembersAccountView
];

/**
 * @function AddUnlinkedTransferAccountWorkflow
 * 
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the "add unlinked transfer account" workflow.
 */
export default function AddUnlinkedTransferAccountWorkflow(props) {
    // Get the inital state of the workflow
    const controller = useBCMSContext();
    const { form, step } = props;

    BCMSRecord.globalControllerFor(Classes, controller);

    const value = getDefaultConfirm(form);
    // Return the workflow component
    return <Workflow value={ value } steps={ steps } step={ step ?? 0 } />
}
// Return the steps of the workflow
export const getWorkflowStepsConfirm = () => steps;

/**
 * @function getDefault
 * 
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefaultConfirm = (form) => {
    const data = form ? { data: { form: form } } : {};
    return data;
};